const lazyloadingFigure = function() {
        /*
         * TODO: Remove jQuery dependency (`$.bind` and `$.trigger`)
         */

    const defaults = {
        selectors: {
            elements: "figure",
        },
        classes: {
            modifier: "is-loaded",
        }
    };

    function init() {

        var elements = document.querySelectorAll(defaults.selectors.elements);

            // Autoload

        let observer;

        if (typeof window.IntersectionObserver === "function"){

            var callback = function(entries, observer){

                for (let i = 0, entry; i < entries.length; i++){

                    entry = entries[i];

            		if (entry.isIntersecting){
                        $(entry.target).trigger("load")
                        observer.unobserve(entry.target);
                    }

                }

            };

            observer = new IntersectionObserver(callback);

        }

            // Init elements

        for (var i = 0; i < elements.length; i++){
            new Loader(elements[i], observer);
        }

    }

    const Loader = function(container, observer) {

        var self = this;

        this.container = container;

        var src = this.container.getAttribute("data-src");

            // Don’t set up loader if data-attribute is missing or image is already given

        if (typeof src === "undefined" || this.container.querySelector("img")){
            return;
        }

            // Bid event for loading image

        $(container).bind("load", function(e){
            self.load();
        });

            // Autoload

        if (typeof observer !== "undefined"){

            var autoload = this.container.hasAttribute("data-autoload") ? this.container.getAttribute("data-autoload") : "0";

            if (autoload !== "0" &&  autoload !== "false"){
                observer.observe(container);
            }

        }

    }

    Loader.prototype.load = function () {

        var self = this;

        var src = this.container.getAttribute("data-src");

        if (! src){
            return false;
        }

        //this.container.style.backgroundImage = "url(" + src + ")";

        //this.container.classList.add(defaults.classes.modifier)

        var image = new Image();

        image.onload = function(){
            self.show(src);
        };

        image.src = src;

    }

    Loader.prototype.show = function (src) {

        this.container.style.backgroundImage = "url(" + src + ")";

        this.container.classList.add(defaults.classes.modifier);

    }

    return {
        init: init
    }

}();

lazyloadingFigure.init();
